import { ParametrosAvancadosInicial } from "../models/parametrosAvancadosModel"
import type { ParametrosAvancadosModel } from "../models/parametrosAvancadosModel"
import { ParametrosAvancadosActionsTypes } from "./parametrosAvancadosActions"
import type { ParametrosAvancadosActionModel } from "./parametrosAvancadosActions"

export function parametrosAvancadosReducer(
    state: ParametrosAvancadosModel,
    action: ParametrosAvancadosActionModel
): ParametrosAvancadosModel {
    switch (action.type) {
        case ParametrosAvancadosActionsTypes.CARREGAR:
            return action.payload

        case ParametrosAvancadosActionsTypes.ATUALIZAR_CAMPO:
            return {
                ...state,
                [action.payload.campo]: action.payload.valor,
            }

        case ParametrosAvancadosActionsTypes.RESETAR:
            return ParametrosAvancadosInicial

        default:
            return state
    }
}
